import { render, staticRenderFns } from "./ActionAddBoleta.vue?vue&type=template&id=7186763c&lang=pug"
import script from "./ActionAddBoleta.vue?vue&type=script&lang=js"
export * from "./ActionAddBoleta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports